import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M.857 11.137V9.208c0-1.065.85-1.928 1.9-1.928h3.48m4.906.643H8.295M7.187 2.78c0 1.065-.85 1.929-1.899 1.929S3.39 3.845 3.39 2.78 4.24.852 5.29.852c1.048 0 1.898.863 1.898 1.928"
    }, null, -1)
  ])))
}
export default { render: render }